"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _EventHandler = _interopRequireDefault(require("../../Events/EventHandler"));

var _DateTime = _interopRequireDefault(require("../../Tools/DateTime"));

var _Payment = require("../Payment");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

class Cashback extends _EventHandler.default {
  constructor(...args) {
    super(...args);

    _defineProperty(this, "min_order", null);

    _defineProperty(this, "tax", null);

    _defineProperty(this, "expire_days", null);

    _defineProperty(this, "cart", null);

    _defineProperty(this, "delivery", null);

    _defineProperty(this, "order_total", null);

    _defineProperty(this, "value", null);

    _defineProperty(this, "expire", null);

    _defineProperty(this, "description", null);
  }

  getValue(cartValue, deliveryValue = 0) {
    this.value = cartValue * (1 / (+this.tax || 1));
    return this.value;
  }

  static fromObject(obj) {
    let cashback = new Cashback();
    Object.keys(obj || {}).forEach(key => {
      let value = obj[key];

      switch (key) {
        case 'min_order':
        case 'tax':
        case 'expire_days':
        case 'cart':
        case 'delivery':
        case 'order_total':
        case 'value':
        case 'expire':
        case 'description':
          cashback[key] = value;
          break;

        case 'times':
          cashback[key] = value || 1;
          break;
      }
    });
    return cashback;
  }

  validate() {
    //Caso o pedido não seja feito através do agregador ou então utilize algum cupom
    if (!this.trigger('cashback/isOnlineOrigin') || this.trigger('cashback/hasGift')) {
      return false;
    } //Caso o cliente esteja pagando com easy_coins


    let payers = this.trigger('cashback/getPayers');
    let hasEasyCoinsPayment = payers.reduce((carry, payer) => carry || payer.method == _Payment.Method.EASY_COINS.alias, false);

    if (hasEasyCoinsPayment) {
      return false;
    }

    let cashbackConfigurations = this.trigger('cashback/getCashbackConfigs'); //Caso a loja não tenha configurado o cashback ou caso o cashback não esteja ativado

    if (!cashbackConfigurations || !cashbackConfigurations.enabled) {
      return false;
    }

    this.tax = cashbackConfigurations.tax;
    this.expire_days = cashbackConfigurations.expire_days;
    let cartTotal = this.trigger('cashback/getCartTotal');
    let deliveryTotal = this.trigger('cashback/getDeliveryTotal');
    let orderTotal = this.trigger('cashback/getOrderTotal');
    this.cart = cartTotal;
    this.delivery = deliveryTotal;
    this.order_total = orderTotal;
    this.value = this.getValue(cartTotal);
    this.expire = _DateTime.default.toMysqlFormat(_DateTime.default.addTime(new Date(), 'day', +this.expire_days || 0));
    return true;
  }

}

exports.default = Cashback;